import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import ReactMarkdown from "react-markdown";
import privacyEng from "../../docs/privacy_eng.md?raw";
import privacyHeb from "../../docs/privacy_heb.md?raw";

/**
 * Privacy Policy Page
 * 
 * IMPORTANT: This page must be accessible to all users, including those who are not logged in.
 * No authentication checks should be added to this component.
 */
export function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const privacyContent = currentLanguage === "he" ? privacyHeb : privacyEng;

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <Card>
            <CardHeader>
              <CardTitle className="text-3xl">{t("privacy.title")}</CardTitle>
            </CardHeader>
            <CardContent>
              <div className="prose prose-sm max-w-none dark:prose-invert">
                <ReactMarkdown
                  components={{
                    h1: ({ node, ...props }) => (
                      <h1 className="text-3xl font-bold mb-4 mt-8 first:mt-0" {...props} />
                    ),
                    h2: ({ node, ...props }) => (
                      <h2 className="text-2xl font-semibold mb-3 mt-6" {...props} />
                    ),
                    h3: ({ node, ...props }) => (
                      <h3 className="text-xl font-semibold mb-2 mt-4" {...props} />
                    ),
                    p: ({ node, ...props }) => (
                      <p className="mb-4 text-muted-foreground leading-relaxed" {...props} />
                    ),
                    ul: ({ node, ...props }) => (
                      <ul className="list-disc list-inside mb-4 space-y-2 text-muted-foreground" {...props} />
                    ),
                    li: ({ node, ...props }) => (
                      <li className="ml-4" {...props} />
                    ),
                    strong: ({ node, ...props }) => (
                      <strong className="font-semibold text-foreground" {...props} />
                    ),
                    a: ({ node, ...props }) => (
                      <a className="text-primary hover:underline" target="_blank" rel="noopener noreferrer" {...props} />
                    ),
                    hr: ({ node, ...props }) => (
                      <hr className="my-8 border-border" {...props} />
                    ),
                  }}
                >
                  {privacyContent}
                </ReactMarkdown>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>
      <Footer />
    </div>
  );
}
